module.exports = __webpack_public_path__ + "static/media/uni_logo_imperial.92471a00.png";